import {Component, Input, Output, EventEmitter} from '@angular/core';
import {AuthService} from '../../../../../services/auth/auth.service';
import {User, UserDetail} from '../../../../../generated/sales-terminal-client';
import {find} from 'lodash-es';

@Component({
  selector: 'app-users-view-legal-list',
  templateUrl: './users-view-legal-list.component.html',
  styleUrls: ['./users-view-legal-list.component.scss']
})
export class UsersViewLegalListComponent {
  private _user: User;
  @Input()
  set user(value: User) {
    this._user = value;
  }
  get user(): User {
    return this._user;
  }
  get legals(): UserDetail[] {
    return this.user.legalPersons?.filter(lp => !lp.isPlaceholder) || [];
  }
  @Input() isView: boolean;
  @Input() isMyProfile: boolean;
  @Output() edit: EventEmitter<number> = new EventEmitter<number>();
  @Output() remove: EventEmitter<number> = new EventEmitter<number>();

  constructor(private authService: AuthService) {}

  public isSameSalespoint(legalPerson: UserDetail): boolean {
    return this.user.userId === this.authService.user.userId && !!find(legalPerson.salespoints, {id: this.authService.user.salespointId});
  }
}
